<template>
  <div class="ui-action-row" :class="`is-${variant}`">
    <div class="ui-action-row__content">
      <div class="ui-action-row__title">
        <slot name="title">{{ $t(title) }}</slot>
      </div>
      <div v-if="hasDescription" class="ui-action-row__description">
        <slot name="description">{{ $t(description) }}</slot>
      </div>
      <slot />
    </div>
    <div v-if="hasActions" class="ui-action-row__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiActionRow',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'transparent'].includes(value)
    }
  },
  computed: {
    hasDescription () {
      return Boolean(this.description || this.$slots.description || this.$scopedSlots.description)
    },
    hasActions () {
      return Boolean(this.$slots.actions || this.$scopedSlots.actions)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-action-row {
  min-width: 0;
  min-height: 82px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--ui-space-lg);
  padding: var(--ui-space-md);
  border: 1px solid var(--ui-border-color);
  border-radius: var(--ui-radius-medium);
  background: rgba(var(--ui-bg-elevated-rgb), .18);
  box-sizing: border-box;
}

.ui-action-row.is-transparent {
  border-color: transparent;
  background: transparent;
}

.ui-action-row__content {
  min-width: 0;
}

.ui-action-row__title {
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-body);
  font-weight: var(--ui-font-weight-medium);
  line-height: 24px;
}

.ui-action-row__description {
  margin-top: var(--ui-space-xs);
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
  line-height: 20px;
}

.ui-action-row__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--ui-control-gap);
}

.ui-action-row__actions ::v-deep .el-button + .el-button {
  margin-left: 0;
}

@media (max-width: 640px) {
  .ui-action-row {
    grid-template-columns: minmax(0, 1fr);
    align-items: start;
  }

  .ui-action-row__actions {
    justify-content: flex-start;
  }
}
</style>
